export const PLANS = [
  {
    id: "ssl-install",
    name: "SSL Installation",
    price: 299.99,
    priceLabel: "$299.99",
    tagline: "Professional SSL setup",
    description: "Complete SSL certificate installation, configuration, and validation across your domain.",
    features: [
      "SSL certificate procurement",
      "Server-side installation",
      "HTTPS redirect + HSTS",
      "Mixed content audit",
      "SSL Labs A+ target grade",
      "1 domain",
    ],
    ctaLabel: "Buy Now",
    popular: false,
  },
  {
    id: "security-audit",
    name: "Website Security Audit",
    price: 799.99,
    priceLabel: "$799.99",
    tagline: "Deep vulnerability review",
    description: "Comprehensive security audit covering OWASP Top 10, headers, and infrastructure.",
    features: [
      "OWASP Top 10 assessment",
      "Malware & backdoor scan",
      "Header & TLS hardening",
      "Written remediation report",
      "1 review call included",
      "30-day follow-up",
    ],
    ctaLabel: "Buy Now",
    popular: false,
  },
  {
    id: "premium-security",
    name: "Premium Website Security",
    price: 999.99,
    priceLabel: "$999.99",
    tagline: "Most popular",
    description: "Everything in Audit plus continuous monitoring, WAF setup, and priority support.",
    features: [
      "Everything in Security Audit",
      "Web Application Firewall setup",
      "24/7 uptime & security monitoring",
      "Priority incident response",
      "Monthly security report",
      "Up to 3 domains",
    ],
    ctaLabel: "Get Started",
    popular: true,
  },
  {
    id: "enterprise-security",
    name: "Enterprise Security",
    price: 2999.99,
    priceLabel: "$2,999.99",
    tagline: "Enterprise-grade",
    description: "Dedicated engineering, SOC-ready hardening, and compliance-first architecture.",
    features: [
      "Dedicated security engineer",
      "SOC2 / ISO27001 readiness",
      "Advanced DDoS mitigation",
      "Custom WAF rulesets",
      "SLA-backed response",
      "Unlimited domains",
    ],
    ctaLabel: "Buy Now",
    popular: false,
  },
  {
    id: "custom-enterprise",
    name: "Custom Enterprise Solution",
    price: null,
    priceLabel: "Contact Sales",
    tagline: "Tailored to your stack",
    description: "White-glove engagement, custom integrations, and a bespoke security architecture.",
    features: [
      "Custom scope & pricing",
      "Executive stakeholder access",
      "Dedicated Slack channel",
      "Quarterly business review",
      "On-site engagement (opt.)",
      "Unlimited scale",
    ],
    ctaLabel: "Contact Sales",
    popular: false,
    contactOnly: true,
  },
];

export const SERVICES = [
  {
    id: "website-design",
    title: "Website Design",
    description: "Premium, conversion-focused websites designed for modern brands.",
    icon: "Palette",
  },
  {
    id: "web-hosting",
    title: "Web Hosting",
    description: "Fast, secure, and reliable hosting engineered for uptime.",
    icon: "Server",
  },
  {
    id: "ssl-certificates",
    title: "SSL Certificates",
    description: "DV, OV, EV, wildcard and multi-domain SSL — installed properly.",
    icon: "Lock",
  },
  {
    id: "domain-registration",
    title: "Domain Registration",
    description: "Secure your identity with premium domain registration and DNS.",
    icon: "Globe",
  },
  {
    id: "website-security",
    title: "Website Security",
    description: "Continuous protection: WAF, malware scanning, and monitoring.",
    icon: "ShieldCheck",
  },
  {
    id: "technical-support",
    title: "Technical Support",
    description: "Expert engineers on-call. SLA-backed response, real solutions.",
    icon: "LifeBuoy",
  },
];

export const FAQ = [
  { q: "What is SSL and why do I need it?", a: "SSL/TLS encrypts data between your visitors and your server, protects credentials, and is a ranking signal for search engines. Modern browsers flag non-HTTPS sites as 'Not Secure'." },
  { q: "How long does SSL installation take?", a: "For most sites, we complete SSL installation and validation in under 24 hours. Enterprise setups with load balancers or complex CDN configurations typically complete within 3 business days." },
  { q: "Do you support wildcard and multi-domain certificates?", a: "Yes. We install DV, OV, EV, wildcard (*.domain.com) and SAN/multi-domain certificates from trusted CAs." },
  { q: "What is included in a security audit?", a: "OWASP Top 10 assessment, TLS/header hardening review, malware & backdoor scan, DNS/CDN configuration review, and a detailed remediation report with prioritized fixes." },
  { q: "Can you migrate my site with zero downtime?", a: "Yes. We use staged DNS cutovers with health checks and rollback plans to ensure your users never see a single dropped request." },
  { q: "What payment methods do you accept?", a: "All checkouts are processed securely through PayPal Hosted Payments. You can pay with PayPal balance, credit card, or debit card." },
  { q: "Do you offer refunds?", a: "Yes — see our Refund Policy. Most fixed-scope services carry a 7-day refund window before work begins." },
  { q: "How do I get support after purchase?", a: "Every plan includes email support at techalphassl@gmail.com. Premium and Enterprise tiers include priority channels with SLA response." },
];

export const PORTFOLIO = [
  { title: "FinEdge Bank", tag: "Fintech", detail: "EV SSL + WAF hardening — reduced attack surface by 92%.", image: "https://images.unsplash.com/photo-1633265486064-086b219458ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxwYWRsb2NrJTIwZGlnaXRhbCUyMHNlY3VyaXR5fGVufDB8fHx8MTc4NDE5NjcwNnww&ixlib=rb-4.1.0&q=85" },
  { title: "Nova Health", tag: "Healthcare", detail: "HIPAA-aligned hardening & PHI-safe hosting migration.", image: "https://images.unsplash.com/photo-1680992044138-ce4864c2b962?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxzZXJ2ZXIlMjByb29tJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3ODQxOTY3MDZ8MA&ixlib=rb-4.1.0&q=85" },
  { title: "Kestrel Retail", tag: "E-commerce", detail: "PCI-conscious checkout, 99.99% uptime, A+ SSL Labs.", image: "https://images.unsplash.com/photo-1691435828932-911a7801adfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxzZXJ2ZXIlMjByb29tJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3ODQxOTY3MDZ8MA&ixlib=rb-4.1.0&q=85" },
  { title: "Meridian SaaS", tag: "SaaS", detail: "Multi-region CDN + wildcard SSL for 40+ subdomains.", image: "https://images.unsplash.com/photo-1633265486064-086b219458ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxwYWRsb2NrJTIwZGlnaXRhbCUyMHNlY3VyaXR5fGVufDB8fHx8MTc4NDE5NjcwNnww&ixlib=rb-4.1.0&q=85" },
];
